import React from "react";
import CartProvider from "../../providers/CartProvider";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppProps } from "../BaseApp";
import OrderProvider from "../../providers/OrderProvider";
import CustomToastContainer from "../../../shared/ui/custom-toast-container";
import Configurator from "../../../pages/configurator";
import { QueryClientProvider } from "@tanstack/react-query";
import AnalyticsProvider from "app/providers/AnalyticsProvider";
import StandardProductProvider from "app/providers/StandardProductProvider";
import ConfigurationOptionsProvider from "app/providers/DoorOptionsProvider";
import { queryClient } from "../queryClient";

const App: React.FC<AppProps> = (props, context) => {
  const getBasename = (): string => {
    return props.configuration.basename || "producten/:slug";
  };

  const canonicalLink = document.querySelector(
    "link[rel='canonical']",
  ) as HTMLLinkElement | null;
  if (canonicalLink) {
    canonicalLink.href = window.location.href;
  }

  return (
    <div className="gg">
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AnalyticsProvider>
            <CartProvider>
              <OrderProvider>
                <CustomToastContainer />
                <ConfigurationOptionsProvider>
                  <StandardProductProvider>
                    <Routes>
                      <Route path={getBasename()} element={<Configurator />} />
                    </Routes>
                  </StandardProductProvider>
                </ConfigurationOptionsProvider>
              </OrderProvider>
            </CartProvider>
          </AnalyticsProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
